///<reference path="../../employee/sections/employee.main.section.ts"/>
///<reference path="../../../components/logging/logging.interface.ts"/>


module Meevo.Plugins.Teachers {
    'use strict';

    export class MainSection extends Meevo.Plugins.Employee.MainSection {

        get auditNounForSave(): Model.NounEnum {
            return Model.NounEnum.Teacher;
        }

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Components.Logging.ILoggingService,
            dataService: Components.BaseClasses.IDataService,
            protected identityService: Components.Common.IIdentityService = null,
            noun: Model.NounEnum = null,
            appSettings: Components.Common.IAppSettings,
            asLocationId: number,
            sectionSecurityKey?: string,
            modalService?: Components.Modal.IModalService,
            context?: Meevo.Components.BaseClasses.IDataMaintenanceContext
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings,
                asLocationId,
                sectionSecurityKey,
                modalService,
                null,
                context,
            );
        }

        public preSave() {
            this.model.employeeEntityTypeEnum = Meevo.Model.EmployeeEntityTypeEnum.Teacher;

            super.preSave();
        }
    }
}